import { chatHistoryUnreadBorderColor, appButtonFontColor } from 'globals/colors';

const styles = {
  unread: {
    position: 'absolute',
    left: '34px',
    top: '-10px',
    background: appButtonFontColor,
    height: '24px',
    width: '24px',
    lineHeight: '13px',
    color: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 11,
    fontWeight: 500,
    border: `3px solid ${chatHistoryUnreadBorderColor}`,
    borderRadius: '50%',
  },
};

export default styles;
